import React from 'react';

import { useTranslate } from '@src/core/hooks';
import PixIcon from '@src/icons/pix-v2.svg';

import { ReceiverDisclaimerCard, ReceiverDisclaimerIcon, ReceiverDisclaimerText } from './styles';

type PixReceiverDisclaimerProps = {
  institution: string;
};

export const PixReceiverDisclaimer = (props: PixReceiverDisclaimerProps) => {
  const { institution } = props;
  const { i18nElement } = useTranslate();

  return (
    <ReceiverDisclaimerCard data-testid='pix-receiver-disclaimer'>
      <ReceiverDisclaimerIcon>
        <PixIcon aria-hidden />
      </ReceiverDisclaimerIcon>
      <ReceiverDisclaimerText>
        {i18nElement('checkout_payment_pix_receiver_disclaimer', { institution })}
      </ReceiverDisclaimerText>
    </ReceiverDisclaimerCard>
  );
};

export default PixReceiverDisclaimer;
